function elementToCompact(element) {
	const result = {};

	if (element.attributes && element.attributes.length) {
		result._attributes = {};
		Array.from(element.attributes).forEach((attr) => {
			result._attributes[attr.name] = attr.value;
		});
	}

	const childElements = Array.from(element.children || []);
	if (!childElements.length) {
		const text = (element.textContent || '').trim();
		if (text) {
			result._text = text;
		}
		return result;
	}

	childElements.forEach((child) => {
		const key = child.nodeName;
		const value = elementToCompact(child);

		if (result[key] === undefined) {
			result[key] = value;
			return;
		}

		if (!Array.isArray(result[key])) {
			result[key] = [result[key]];
		}

		result[key].push(value);
	});

	return result;
}

export default function xmlToCompact(xmlString) {
	const parser = new DOMParser();
	const document = parser.parseFromString(xmlString, 'application/xml');
	const parseError = document.querySelector('parsererror');

	if (parseError) {
		throw new Error('Invalid XML document');
	}

	const root = document.documentElement;
	return {
		[root.nodeName]: elementToCompact(root),
	};
}